export class ApproverPortalService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? ApproverPortalService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${ApproverPortalService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getPending() {
        const response = await this.http.get(this.buildUrl('pending'));
        return response.data ?? [];
    }
    async approveLine(quotationLineId) {
        const response = await this.http.put(this.buildUrl(`${quotationLineId}/approve`), {});
        return response.data;
    }
    async rejectLine(quotationLineId, reason) {
        const response = await this.http.put(this.buildUrl(`${quotationLineId}/reject`), { reason });
        return response.data;
    }
    async getHistory() {
        const response = await this.http.get(this.buildUrl('history'));
        return response.data ?? [];
    }
}
ApproverPortalService.DEFAULT_SERVICE_PATH = 'procurements';
ApproverPortalService.BASE_PATH = 'api/procurement-portal/approvals';
//# sourceMappingURL=ApproverPortalService.js.map